import * as requests from "../coraWebComponents/utils/requests";
import urls from "../constants/Urls";
import _ from "lodash";

const postMessageToMap = async (type, value) => {
  const frame = document.getElementById("map_iframe");
  if (!frame) return;
  frame.contentWindow.postMessage({ type: type, value: value }, "*");

  const data = await new Promise((resolve) => {
    window.onmessage = (event) => {
      resolve(event.data);
    };
  });
  return data;
};

export const getImage = async () => {
  const value = `$("canvas.ol-unselectable")[0].toDataURL("image/png")`;

  let image = null;
  await postMessageToMap("request", value).then(async (data) => {
    // For Firefox it is necessary to delay revoking the ObjectURL
    image = await new Promise((resolve) =>
      setTimeout(() => {
        resolve(data.value);
      }, 100)
    );
  });

  return { image };
};

export const getExtentCoords = async () => {
  const value = `(function() { 
    try { 
      const symbol_layer =  map.getLayerByName('symbol_layer');
      const extent = map.getView().calculateExtent(map.getSize());
      const extent2 = TransformBounds(extent, "EPSG:102067", getProjection());
           
      if (symbol_layer.getSource().getFeatures().length === 0) { 
        const geometry = new ol.geom.Polygon.fromExtent(extent);
        const extent_polygon = new ol.Feature(geometry);
        extent_polygon.setId('extent_polygon');
        symbol_layer.getSource().addFeature(extent_polygon);
      }

      return { 
        extent: extent2,
        features:symbol_layer.getSource().getFeatures().map(f=>{

          const coords = f.getGeometry().getCoordinates(true);
          const coords2 = coords[0].map(p => TransformPoint([p[0], p[1]], getProjection(), "EPSG:102067"));

          return {
            coords: [coords2]
          }
        })
      }
    } catch (e) { 
      return null 
    }
  }())`;

  let features = [];
  let extent = [];
  await postMessageToMap("request", value).then((data) => {
    features = _.get(data.value, "features");
    extent = _.get(data.value, "extent");
  });

  const coords = features.map(f => { return { type: "BPolygon", coordinates: f.coords[0].map(x => `${x[0]}`.replace(',', '.') + ',' + `${x[1]}`.replace(',', '.')).join(' ') } });

  return { coords, extent: extent.map((x, i) => { return (i < 2 ? x + 20 : x - 20); }) }
};

export const getURL = async ({ CS, CO, ULICA, OBEC }) => {
  try {
    let res = await requests.post(urls.MAPA_URL, { CS, CO, ULICA, OBEC });
    return res;
  } catch (error) {
    throw error;
  }
};

export const getURLBasedOnLatLng = async ({ lat, lng }) => {
  try {
    const url = `${urls.MAPA_URL_LAT_LNG}?lat=${lat}&lng=${lng}`;
    let res = await requests.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getLatLngFromGoogleMap = async ({ CS, CO, ULICA, OBEC }) => {
  try {
    const googleMapKey = window.config.google.mapKey;
    const address = `
    ${CS ? CS + "+" : ""}
    ${CO !== "" ? CO + "+" : ""}
    ${ULICA},+${OBEC}`;

    const googleMapURL = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${googleMapKey}`;

    let response = await fetch(googleMapURL);
    let data = {};
    data = await response.json(data);

    const lat = _.get(data, "results[0].geometry.location.lat");
    const lng = _.get(data, "results[0].geometry.location.lng");

    return { lat: lat || "", lng: lng || "" };
  } catch (error) {
    throw error;
  }
};
